module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("Abbreviations and Acronyms")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AAS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("American Astronautical Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ABMA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Army Ballistic Missile Agency")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("air force")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AFHRA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Air Force Historical Research Agency")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AFSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Air Force Systems Command")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AMC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Air Materiel Command")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ARDC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Air Research and Development Command")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ASAT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Arbeitsgemeinschaft Satelitenträger")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("AT&T")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("American Telephone and Telegraph")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ATC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Air Training Command")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("BMC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Ballistic Missile Command")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("BSD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Ballistic Systems Division")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("CBI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Charles Babbage Institute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("CCB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("configuration control board")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("CERN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Conseil Européen pour Recherche Nucléaire")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("CETS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Conférence Européene de Télécommunications par Satellites")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("CNES")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Centre National d’Études Spatiales")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("COPERS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Commission Préparatoire Européene de Recherches Spatiales")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("CPFF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("cost plus fixed fee")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("DCAS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Deputy Commander for Aerospace Systems")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("DOD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Department of Defense")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ELDO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("European Space Vehicle Launcher Development Organisation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ERNO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Entwicklungsring Nord")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ESA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("European Space Agency")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ESRO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("European Space Research Organisation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ESTEC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("European Space Technology Centre")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("EUI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("European University Institute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("GE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("General Electric")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("GSFC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Goddard Space Flight Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("HAC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Hughes Aircraft Company")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("HAEUI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Historical Archives of the European University Institute")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("HEOS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Highly Eccentric Orbit Satellite")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("HQ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("headquarters")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("HSO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("History Support Office")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("IBM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("International Business Machines")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("ICBM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("intercontinental ballistic missile")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("IRBM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("intermediate-range ballistic missile")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("JPL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Jet Propulsion Laboratory")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("JPLA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("JPL Archives")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("JSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Johnson Space Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("KSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Kennedy Space Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("LC/SPP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Library of Congress, Samuel Phillips Papers")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("LCT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Laboratoire Central de Télécommunications")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("LEM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Lunar Excursion Module")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MAU")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("million accounting units")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MBB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Messerschmitt-Bölkow-Blohm")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MESH")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Matra, Entwicklungsring Nord, Saab, and Hawker Siddeley")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MIS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("management information system")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MIT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Massachusetts Institute of Technology")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Manned Spacecraft Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("MSFC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Marshall Space Flight Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("NAA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("North American Aviation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("NACA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("National Advisory Committee for Aeronautics")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("NASA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("National Aeronautics and Space Administration")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("NASAHO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("NASA History Office")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("NATO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("North Atlantic Treaty Organization")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("OECD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Organization for Economic Cooperation and Development")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("OMSF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Office of Manned Space Flight")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("PDR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Preliminary Design Review")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("PERT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Program Evaluation and Review Technique (or Research Task)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("QA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("quality assurance")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("R&D")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("research and development")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("RCA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Radio Corporation of America")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("RFP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("request for proposal")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("R-W")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Ramo-Wooldridge")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("S&ID")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Space and Information Systems Division")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("SAC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Strategic Air Command")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("SAPO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Special Aircraft Projects Office")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("SE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("systems engineering")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("SEREB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Société pour l’Étude et la Réalisation d’Engins Balistiques")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("SETIS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Société d’Étude et d’Intégration de Systèmes Spatiaux")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("SMC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("USAF Space and Missile Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("STG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Space Task Group")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("STL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Space Technology Laboratories")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("TD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Thor-Delta")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("TQM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("total quality management")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("TRW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Thompson-Ramo-Wooldridge")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("USAF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("U.S. Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("WADC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Wright Air Development Center")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("WDD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Western Development Division")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "abbr"
  }, [_vm._v("WSPO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "abb"
  }, [_vm._v("Weapon System Project Office"), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6c21d1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abb.vue
// module id = 84
// module chunks = 0